import S from "sanctuary";
import InternalUserInfoForm from "@/components/administeredUsers/InternalUserInfoForm";
import { createSelector } from "reselect";
import * as Nested from "@/util/Nested";
import * as AlertBarState from "@/components/alert-bar/AlertBar.state";
import {
  getCheckAdministeredUserPending,
  getCheckAdministeredUserError,
  getCreateAdministeredUserPending,
  getCreateAdministeredUserError,
  getAdministeredUserBeingEdited,
} from "@/components/administeredUsers/AdministeredUsers.state";
import { requestClient } from "@/components/currentUser/CurrentUser.state";

const INITIAL_STATE = {
  requestPending: false,
  requestError: false,
  clients: S.Nothing,
  clientAdminForm: false,
};

export const REQUEST_CLIENTS = "adminPage/REQUEST_CLIENTS";
export const requestClients = () => ({
  type: REQUEST_CLIENTS,
});

export const GET_CLIENTS_STARTED = "adminPage/GET_CLIENTS_STARTED";
export const requestClientsStarted = () => ({
  type: GET_CLIENTS_STARTED,
});

export const GET_CLIENTS_SUCCEEDED = "adminPage/GET_CLIENTS_SUCCEEDED";
export const setClients = (data) => ({
  type: GET_CLIENTS_SUCCEEDED,
  payload: { data },
});

export const GET_CLIENTS_FAILED = "adminPage/GET_CLIENTS_FAILED";
export const setClientsError = ({ error }) => ({
  type: GET_CLIENTS_FAILED,
  payload: { error },
});

export const SET_CLIENT_ADMIN_FORM = "adminPage/SET_CLIENT_ADMIN_FORM";
export const setClientAdminForm = (payload) => ({
  type: SET_CLIENT_ADMIN_FORM,
  payload,
});

export const SUBMIT_CREATE_CLIENT_ADMIN = "adminPage/SUBMIT_CREATE_CLIENT_ADMIN";
export const submitCreateClientAdmin = () => ({
  type: SUBMIT_CREATE_CLIENT_ADMIN,
});

export const _reducer = (state = INITIAL_STATE, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case GET_CLIENTS_STARTED:
      return {
        ...state,
        requestPending: true,
      };
    case GET_CLIENTS_SUCCEEDED:
      return {
        ...state,
        requestPending: false,
        clients: S.Just(payload.data.clients.value),
        requestError: S.Nothing,
      };
    case GET_CLIENTS_FAILED:
      return {
        ...state,
        clients: S.Nothing,
        requestPending: false,
        requestError: S.Just(payload),
      };
    case SET_CLIENT_ADMIN_FORM:
      return {
        ...state,
        clientAdminForm: payload,
      };
    default:
      return state;
  }
};

const getState = (state) => state.adminPage;
export const getClients = (state) => getState(state).clients;
export const getClientAdminForm = (state) => getState(state).clientAdminForm;
export const getSortedClients = createSelector(
  getClients,
  S.pipe([S.map(S.sortBy(S.prop("brand")))])
);

export const getClientsNameList = createSelector(
  getSortedClients,
  S.pipe([S.fromMaybe([]), S.map(S.prop("brand"))])
);

export const _mapStateToProps = (state) => ({
  ...state.adminPage,
  currentUser: state.currentUser,
  clientsNameList: getClientsNameList(state),
  checkUserRequestIsPending: getCheckAdministeredUserPending(state),
  checkUserRequestError: S.isJust(getCheckAdministeredUserError(state)),
  createUserRequestIsPending: getCreateAdministeredUserPending(state),
  createUserRequestError: S.isJust(getCreateAdministeredUserError(state)),
  clients: S.fromMaybe([])(getSortedClients(state)),
  clientAdminForm: getClientAdminForm(state),
  userBeingEdited: getAdministeredUserBeingEdited(state),
});

export const _mapDispatchToProps = (dispatch) => ({
  requestClient: (payload) => dispatch(requestClient(payload)),
  setClientAdminForm: (payload) => dispatch(setClientAdminForm(payload)),
  submitCreateClientAdmin: () => dispatch(submitCreateClientAdmin()),
});

export const ADMIN_PAGE_ALERT_BAR_ACTION = "adminPage/ADMIN_PAGE_ALERT_BAR_ACTION";
export const adminPageAlertBarAction = Nested.nestedAction(
  ADMIN_PAGE_ALERT_BAR_ACTION
);

export const CREATE_CLIENT_ADMIN_ALERT_BAR_ACTION =
  "adminPage/CREATE_CLIENT_ADMIN_ALERT_BAR_ACTION";
export const createClientAdminAlertBarAction = Nested.nestedAction(
  CREATE_CLIENT_ADMIN_ALERT_BAR_ACTION
);
export const CREATE_CLIENT_ADMIN_FORM_ACTION =
  "adminPage/CREATE_CLIENT_ADMIN_FORM_ACTION";
export const createClientAdminFormAction = Nested.nestedAction(
  CREATE_CLIENT_ADMIN_FORM_ACTION
);

const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    forms: {
      createClientAdminForm: {
        ...InternalUserInfoForm,
        actionType: CREATE_CLIENT_ADMIN_FORM_ACTION,
      },
    },
    alertBars: {
      createClientAdminAlertBar: {
        ...AlertBarState,
        actionType: CREATE_CLIENT_ADMIN_ALERT_BAR_ACTION,
      },
      adminPageAlertBar: {
        ...AlertBarState,
        actionType: ADMIN_PAGE_ALERT_BAR_ACTION,
      },
    },
  },
  "adminPage"
);

const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };
